<template>
  <div>

    <!-- Logo general -->
    <div class="w-full px-2">

      <!-- Titulo -->
      <b-row class="m-0 p-3 bg-blue-sistem">
        <h4><strong>Control de imágenes</strong></h4>
      </b-row>

      <div class="mt-2">
        <b-tabs
          content-class="mt-3 p-0"
          active-nav-item-class="font-weight-bold"
          justified
        >

          <!-- Logo general -->
          <b-tab title="Logo general" active>
            <b-row class="shodow rounded">

            <b-col sm="12" md="12" class="p-3">
              <h5><strong>Imagen general</strong></h5>
            </b-col>

            <!-- Formulario -->
            <b-col sm="12" md="8" class="pr-2 p-0">

              <div class="">
                <div class="px-3">
                  <p class="text-gray m-0 mt-2 px-2 alert alert-info"><i class="fa fa-info-circle mr-1"></i> El logo general se visualizará en todas las pantallas necesarias del sistema, ten presente que si el <strong>Logo secundario</strong> es asignado a un servicio específico este logo ya no se mostrara.</p>
                </div>

                <b-form class="mt-2 px-3 pb-3" method="POST" enctype="multipart/form-data" data-vv-scope="imagen">

                  <!-- Direccion de la imagen -->
                  <div class="form-group">
                    <label for="orientacion"><strong>Seleccionar horientación</strong> (*)</label>
                    <el-select id="orientacion" v-model="selectedImagen.orientacion" :options="listadoOrientaciones.orientaciones">
                      <el-option v-for="orientacion in listadoOrientaciones.orientaciones"
                        :label="orientacion"
                        :value="orientacion"
                        :key="orientacion"
                      />
                    </el-select>
                  </div>

                  <!-- Imagen -->
                  <div v-if="validarPermisoComponente('empresa-editar-imagenes')" class="form-group">
                    <label for="archivo"><strong>Seleccionar imagen</strong>(*) </label>
                    <b-form-file id="archivo"
                      name="archivo"
                      type="file"
                      accept="image/jpeg, image/png, image/jpg"
                      placeholder="Seleccione una imagen"
                      @change="getAdjunto"
                      v-model="archivo"
                      data-vv-delay="1000"
                      data-vv-as=" "
                      v-validate="'required|mimes:image/jpeg,image/png,image/jpg'"
                    />
                  </div>

                  <!-- Guardar -->
                  <div v-if="validarPermisoComponente('empresa-editar-imagenes')" class="d-flex justify-content-end">
                    <b-button variant="primary" @click="guardar()">
                      <i class="fa fa-floppy-o"></i>
                      <span class="ml-1">Guardar cambios</span>
                    </b-button>
                  </div>

                </b-form>
              </div>

            </b-col>

            <!-- Visulizador de la imagen -->
            <b-col sm="12" md="4" class="pl-2 p-0 h-full">

              <div class="mt-2 border-left-previewer">
                <div class="bg-blue-sistem text-center shodow">
                  <strong>Visor de imagen</strong>
                </div>

                <div class="p-3">

                  <div class="mt-4" style="margin:auto;" v-if="selectedImagen.imagen != ''">
                    <h4 v-if="selectedImagen.tipo == 'contratista' && contratista == 1">
                      Logo de contratista
                    </h4>
                    <h4 v-else-if="selectedImagen.tipo == 'empresa' && contratista == 1">
                      Logo de generales
                    </h4>
                    <b-img style="margin:auto;" thumbnail fluid :src="selectedImagen.imagen" alt="Image 1"/>
                  </div>

                </div>
              </div>

            </b-col>

          </b-row>
          </b-tab>

          <!-- Logo secundario -->
          <b-tab title="Logo secundario" v-on:click="getSecondaryImage(selectedEmpresa.id)">

            <b-row class="shodow rounded">

            <b-col sm="12" md="12" class="p-3">
              <h5><strong>Logo secundario</strong></h5>
            </b-col>

            <!-- Formulario -->
            <b-row>
              <b-col sm="12" md="8">

                <div class="">
                  <div class="px-3">
                    <p class="text-gray m-0 mt-2 px-2 alert alert-info"><i class="fa fa-info-circle mr-1">
                    </i> Puedes asignar el Logo secundario a los servicios disponibles, esto hará que se muestre con
                     prioridad sobre el Logo general.</p>
                  </div>

                  <b-form class="mt-2 px-3 pb-3" method="POST" enctype="multipart/form-data" data-vv-scope="secondaryImage">

                    <!-- Imagen -->
                    <div v-if="validarPermisoComponente('empresa-editar-imagenes')" class="form-group">
                      <label for="secondary_image"><strong>Seleccionar imagen</strong> (*)</label>
                      <b-form-file id="secondary_image"
                        name="secondary_image"
                        type="file"
                        accept="image/jpeg, image/png, image/jpg"
                        placeholder="Seleccione una imagen"
                        v-model="secondaryImage.image"
                        data-vv-delay="1000"
                        data-vv-as=" "
                        v-validate="'mimes:image/jpeg,image/png,image/jpg'"
                      />
                      <span class="text-danger span-error small">{{ errors.first('secondaryImage.secondary_image') }}</span>

                      <p class="text-gray m-0 mt-2 px-2 alert alert-warning">
                        <i class="fa fa-info-circle mr-1" />
                        <strong>Importante: </strong><span> Guardar sin una imagen valida/vacia implicara que en los servicios seleccionados se imprima la sección sin dicha imagen.</span>
                      </p>

                    </div>

                    <!-- Direccion de la imagen -->
                    <div class="form-group">
                      <label for="secondary_services"><strong>Seleccionar servicios</strong> (*)</label>
                      <el-select id="secondary_services" v-model="secondaryImage.services" :options="services" filterable clearable multiple>
                        <el-option v-for="service in services"
                          :label="service.title"
                          :value="service.val"
                          :key="service.val"
                        />
                      </el-select>
                    </div>

                    <!-- Guardar -->
                    <div v-if="validarPermisoComponente('empresa-editar-imagenes')" class="d-flex justify-content-end">
                      <b-button ty variant="primary" @click="onHanldeStoreSecondaryImage()">
                        <i class="fa fa-floppy-o"></i>
                        <span class="ml-1">Guardar cambios</span>
                      </b-button>
                    </div>

                  </b-form>
                </div>

              </b-col>

              <!-- Visulizador de la imagen -->
              <b-col sm="12" md="4">

                <div class="mt-2 border-left-previewer">
                  <div class="bg-blue-sistem text-center shodow">
                    <strong>Visor de imagen</strong>
                  </div>

                  <div class="p-4">
                    <b-img v-if="imgPreviewPath && imgPreviewPath != null" style="margin:auto;" thumbnail fluid
                      :src="imgPreviewPath"
                      alt="Imagen secundaria."
                    />
                  </div>
                </div>

              </b-col>
            </b-row>

          </b-row>

          </b-tab>

        </b-tabs>
      </div>

    </div>

  </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from 'vuex';

// Componentes
import Swal from 'sweetalert2';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  props: ['contratista'],
  data() {
    return {
      archivo: null,
      image: '',
      mainProps: {blank: true, width: 75, height: 75, class: 'm1'},
      file: '',
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  async mounted() {
    await this.cambiaContratista(0);
    await this.getImagen({
      companyId: this.$route.params.id,
      module: 'COMPANY'
    });
  },
  computed: {
    ...mapState('empresa', [
      'selectedImagen',
      'listadoOrientaciones',
      'selectedEmpresa'
    ]),
    // Manejas estados del modulo de la segunda imagen de la empresa
    ...mapState('companySecondaryImage', [
      'services',
      'secondaryImage',
      'imgPreviewPath'
    ])
  },
  methods: {
    onImageChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadImage() {
      axios.post('/image/store', {avatar: this.image}).then(response => {
        if (response.data.success) {
        }
      });
    },
    async guardar() {
      await this.$validator.validateAll('imagen')
        .then(async (validado) => {
          if (validado) {
            const formData = new FormData();
            formData.append('avatar', this.file);
            await this.guardaImage(formData);
          }
        });
    },
    getAdjunto(event) {
      this.file = event.target.files[0];
    },
    /**
     * Guardar la segunda imagen para la empresa.
     * @author Fernando Claros
     */
    async onHanldeStoreSecondaryImage() {

      await this.$validator.validateAll('secondaryImage')
        .then(async (isValidData) => {

          if (isValidData) {

            if (!this.secondaryImage.image && !this.imgPreviewPath) {

              Swal.fire({
                icon: 'info',
                title: 'Logo secundario',
                text: 'Debe seleccionar una imagen.',
                showConfirmButton: true
              });
              return false;

            }

            if (this.secondaryImage.services.length == 0) {
              Swal.fire({
                icon: 'info',
                title: 'Logo secundario',
                text: 'Debe seleccionar al menos un servicio.',
                showConfirmButton: true
              });
              return false;
            }

            const formData = new FormData();

            if(this.secondaryImage.image) formData.append('file', this.secondaryImage.image);
            formData.append('apply_service_inventory', this.isSelectedService('inventory'));
            formData.append('apply_service_fds', this.isSelectedService('fds'));
            formData.append('apply_service_labels', this.isSelectedService('labels'));
            formData.append('apply_service_dashboard', this.isSelectedService('dashboard'));
            formData.append('company_id', this.selectedEmpresa.id);

            await this.storeSecondaryImage(formData);

          }
        });

    },
    /**
     * Verifica si el servicio fue seleccionado.
     * @author Fernando Claros
     */
    isSelectedService(service) {
      return this.secondaryImage.services.find(x => x == service) ? 1 : 0;
    },
    ...mapMutations('empresa', ['cambiaContratista', 'resetImagen']),
    // Mutaciones del modulo de la imagen secundaria de la empresa
    ...mapMutations('companySecondaryImage', ['setSecondaryImage']),
    ...mapActions('empresa', [
      'getImagen',
      'guardaImage'
    ]),
    // Acciones del modulo de la imagen secundaria de la empresa
    ...mapActions('companySecondaryImage', {
      storeSecondaryImage: 'store',
      getSecondaryImage: 'getByCompanyId'
    })
  },
};
</script>

<style scoped>

  .shodow{
    box-shadow: 0 2px 16px -3px #ececec;
  }

  .bg-headers{
    background-color: #097b83;
  }

  .bg-headers-secondary{
    background-color: #f7f7f7;
  }

  .h-completed {
    height: 100%;
  }

  .border-left-previewer{
    padding: 0 10px;
  }

  .bg-blue-sistem{
    background-color: #e0f3f8;
    padding: 17pt;
  }

</style>
